import { Section } from "@/components/common/section/Section";
import styles from "./Accessories.module.scss";
import { Accessory, AccessoryProps } from "./accessory/Accessory";

export type AccessoriesProps = {
  title: string;
  accessories: AccessoryProps[];
};

export const Accessories = ({ title, accessories }: AccessoriesProps) => {
  return (
    <Section containerStyle={styles.accessoriesSectionColor}>
      <div className={styles.accessoriesList}>
        <p className={styles.title}>{title}</p>
        <div className={styles.background}>
          <div className={styles.accessoriesContainerLayout}>
            <div className={styles.accessoriesCardsLayout}>
              {accessories.map((accessory, index) => (
                <Accessory {...accessory} key={index} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </Section>
  );
};
